<template>
  <aside class="page-sidebar">
    <div class="page-logo">
      <img
        src="img/logo.png"
        alt="フュージョンアウトドアロゴ"
        aria-roledescription="logo"
      />
    </div>
    <!-- BEGIN PRIMARY NAVIGATION -->
    <nav id="js-primary-nav" class="primary-nav" role="navigation">
      <!-- ---------------------- -->
      <ul id="js-nav-menu" class="nav-menu">
        <li v-if="showFlags.showDashboard_1">
          <a href="javascript:void(0);" @click="goTo('/dashboard', $event)">
            <!-- <i class="fal fa-globe"></i> -->
            <span class="nav-link-text" data-i18n="nav.blankpage"
              >ダッシュボード
              <!-- <span class="badge badge-icon position-relative ml-2">99</span> 
              TODO:お知らせ数表示
              -->
            </span>
          </a>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showSales_2"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <!-- <i class="fal fa-tasks"></i> -->
            <span class="nav-link-text" data-i18n="nav.category">売上管理</span>
          </a>
          <ul>
            <li
              v-if="showFlags.showProjectinput_100"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/projectInput', $event)"
              >
                <!-- <router-link to="/projectInput"> -->
                <!-- <a href="/jyutyuinput"> -->
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >案件情報入力</span
                >
                <!-- </a> -->
                <!-- </router-link> -->
              </a>
            </li>
            <li
              v-if="showFlags.showProjectsearch_101"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/projectSearch', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >案件情報検索</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSalessearch_102"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/salesSearch', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >売上情報検索</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSuppliersearch_103"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/supplierSearch', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >仕入情報検索</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSimulation_105"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/projectMigration', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >シミュレーション</span
                >
              </a>
            </li>
            <!-- <li @click.stop="selectMenu($event)">
              <router-link to="/invoiceNumberAssignment">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >請求書NR取得</span
                >
              </router-link>
            </li> -->
            <li v-if="showFlags.showLock_104" @click.stop="selectMenu($event)">
              <a href="javascript:void(0);" @click="goTo('/dataLock', $event)">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >データロック</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showReport_3"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <!-- <i class="fal fa-file-alt"></i> -->
            <span class="nav-link-text" data-i18n="nav.category">帳票作成</span>
          </a>
          <ul>
            <li
              v-if="showFlags.showInvsearch_200"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/invoiceSearch', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >請求管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showDoclist_205"
              @click.stop="selectMenu($event)"
            >
              <a href="javascript:void(0);" @click="goTo('/doclist', $event)">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >文書管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showAnnIndivperfsheet_201"
              @click.stop="selectMenu($event)"
            >
              <a href="javascript:void(0);" @click="goTo('/dashboard', $event)">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >年次成績表（個人）</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showFinalABClist_202"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/finalABCList', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >確定ＡＢＣリスト</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSalesforesolo_203"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/salesForecastNonConsolidated', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >売上予想表（単独）</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSalescust_204"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/salesByCustomer', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >取引先売上高</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showMatchingList_206"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/matchingList', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >照合リスト</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showDaily_4"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <span class="nav-link-text" data-i18n="nav.category">営業管理</span>
          </a>
          <ul>
            <li
              v-if="showFlags.showDailyrepinput_300"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/dailyReportEdit', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >日報入力</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showDailyrepsearch_301"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/dailyReportSearchIdeas', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >日報検索</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showMaster_5"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <!-- <i class="fal fa-key"></i> -->
            <span class="nav-link-text" data-i18n="nav.category"
              >マスタ情報管理</span
            >
          </a>
          <ul>
            <li
              v-if="showFlags.showSalesdestination_400"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/salesDestinationList', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >売上先マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSupplier_401"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/supplierList', $event)"
              >
                <span class="nav-link-text" data-i19n="nav.utilities_menu_child"
                  >仕入先マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showSponsor_407"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/sponsorList', $event)"
              >
                <span class="nav-link-text" data-i19n="nav.utilities_menu_child"
                  >広告主マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showEmployee_402"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/employeeList', $event)"
              >
                <span class="nav-link-text" data-i20n="nav.utilities_menu_child"
                  >社員マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showBankaccount_403"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/bankAccountList', $event)"
              >
                <span class="nav-link-text" data-i21n="nav.utilities_menu_child"
                  >口座マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showBBInfo_404"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/bulletinBoardInfomationList', $event)"
              >
                <span class="nav-link-text" data-i22n="nav.utilities_menu_child"
                  >掲示板マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showBasegoal_405"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/baseGoalList', $event)"
              >
                <span class="nav-link-text" data-i23n="nav.utilities_menu_child"
                  >拠点目標マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showPersonalgoal_406"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/personalGoalList', $event)"
              >
                <span class="nav-link-text" data-i23n="nav.utilities_menu_child"
                  >個人目標マスタ管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showHoliday_408"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/holidayList', $event)"
              >
                <span class="nav-link-text" data-i23n="nav.utilities_menu_child"
                  >休日マスタ管理</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showRequest_6"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <span class="nav-link-text" data-i18n="nav.category"
              >申請書管理</span
            >
          </a>
          <ul>
            <li
              v-if="showFlags.showRequestlist_500"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/shinseisyolist', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >申請書一覧</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showAttendance_7"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <span class="nav-link-text" data-i18n="nav.category">勤怠管理</span>
          </a>
          <ul>
            <li
              v-if="showFlags.showAttendancelist_600"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/attendanceList', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >勤怠管理</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showAttendanceedit_601"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/attendanceEdit', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >出勤表</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- ---------------------- -->
        <li
          v-if="showFlags.showSpecial_8"
          @click.stop="selectMenu($event)"
          class="open"
        >
          <a href="#" title="Category" data-filter-tags="category">
            <!-- <i class="fal fa-stamp"></i> -->
            <span class="nav-link-text" data-i18n="nav.category">特殊操作</span>
          </a>
          <ul>
            <li
              v-if="showFlags.showHistory_700"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/operationHistoryList', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >操作履歴</span
                >
              </a>
            </li>
            <li
              v-if="showFlags.showMknxtyrdata_701"
              @click.stop="selectMenu($event)"
            >
              <a
                href="javascript:void(0);"
                @click="goTo('/makeNextYearData', $event)"
              >
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >来期見通しデータ作成</span
                >
              </a>
            </li>
          </ul>
        </li>
        <!-- <li @click.stop="selectMenu($event)" class="open">
          <a href="#" title="Category" data-filter-tags="category">
            <span class="nav-link-text" data-i18n="nav.category"
              >新機能用モック</span
            >
          </a>
          <ul>
            <li @click.stop="selectMenu($event)">
              <router-link to="/profit_uriagesakiedit">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >【検討中】売上先マスタ</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/profit_shiiresakiedit">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >【検討中】仕入先マスタ</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/profit_itemlist">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >【検討中】商品マスタ</span
                >
              </router-link>
            </li>
          </ul>
        </li> -->
        <!-- <li @click.stop="selectMenu($event)" class="open active">
          <a href="#" title="Category" data-filter-tags="category">
            <i class="fal fa-file"></i>
            <span class="nav-link-text" data-i18n="nav.category">test</span>
          </a>
          <ul>
            <li @click.stop="selectMenu($event)">
              <router-link to="/analytics_dashboard">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >analytics_dashboard</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >top-test</span
                >
              </router-link>
            </li>
            <li class="disabled" @click.stop="selectMenu($event)">
              <a
                href="javascript:void(0);"
                title="Disabled item"
                data-filter-tags="utilities disabled item"
                class="waves-effect waves-themed"
              >
                <span
                  class="nav-link-text"
                  data-i18n="nav.utilities_disabled_item"
                  >Disabled item</span
                >
              </a>
            </li>
          </ul>
        </li> -->
        <!-- Example of open and active states -->
        <!-- <li @click.stop="selectMenu($event)" class="open active">
          <a href="#" title="Category" data-filter-tags="category">
            <i class="fal fa-plus"></i>
            <span class="nav-link-text" data-i18n="nav.category"
              >Open Item</span
            >
          </a>
          <ul>
            <li @click.stop="selectMenu($event)">
              <router-link to="/blank">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >blank</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/empty">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >empty</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/toaster">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >toaster</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/salert">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >SweetAlert2</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/loader">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >Loader</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/alerts">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >Alerts</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/teble4goodtable">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >Teble4goodtable</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/vueselect">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >Vueselect</span
                >
              </router-link>
            </li>
            <li @click.stop="selectMenu($event)">
              <router-link to="/modal">
                <span class="nav-link-text" data-i18n="nav.utilities_menu_child"
                  >Modal</span
                >
              </router-link>
            </li>
          </ul>
        </li> -->
      </ul>
      <div class="filter-message js-filter-message bg-success-600"></div>
    </nav>
    <!-- END PRIMARY NAVIGATION -->
  </aside>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_Authorization_menu } from "../../constants/Cl_Authorization_menu";
import { Cl_common } from "@/functions/Cl_common";
import { isProdEnv } from "furukawa-common/src/common/constant/Constants";

@Options({})
export default class Tm_leftnavi extends Vue {
  /**
   * パフォーマンス問題の解決案としてテスト的に実装中
   * 残課題：グローバルなメソッドとして宣言して、どこからでも呼び出せるようにしたい
   * 　　　　色々なパターンでも問題ないかの検証
   * @param url
   * @param event
   */
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  showFlags = new Cl_Authorization_menu();

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //設定された権限からメニューの表示非表示を制御
    this.showFlags.getAuthorization(this.$store);
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * Menuクリック時の処理
   * @param event
   */
  async selectMenu(event: any) {
    // console.log(event);
    //開閉Menuかの判断
    if (event.target.closest("li").classList.contains("open")) {
      // console.log("toggle");
      event.target.closest("li").classList.toggle("active");
    } else {
      //ルーターの処理に移動
      // // console.log("add");
      // // 1.他のactiveを削除
      // let elements = document.getElementsByTagName("li");
      // Array.prototype.forEach.call(elements, function (element) {
      //   if (!element.classList.contains("open")) {
      //     element.classList.remove("active");
      //   }
      // });
      // //2.自身のactivを付ける
      // event.target.closest("li").classList.add("active");
    }
  }
  isProd(): boolean {
    return isProdEnv();
  }
  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>

<style scoped>
.page-logo img {
  width: 40px;
  height: auto;
  margin: 0 auto;
}
</style>
